export interface ErrorHeading {
  headingText: string;
  buttonText: string;
}

export const languageMap: Record<string, ErrorHeading> = {
  "en-us": {
    headingText: "An error has occurred, please try again later.",
    buttonText: "Contact Us",
  },
  "en-ca": {
    headingText: "An error has occurred, please try again later.",
    buttonText: "Contact Us",
  },
  "fr-ca": {
    headingText: "Une erreur s'est produite, veuillez réessayer plus tard.",
    buttonText: "Nous Contacter",
  },
  "nl-nl": {
    headingText: "Er is een fout opgetreden. Probeer het later nog eens.",
    buttonText: "Contact Us", // Needs translation
  },
  "de-de": {
    headingText:
      "Es ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.",
    buttonText: "Kontakt", // Validate
  },
  "it-it": {
    headingText: "Si è verificato un errore. Riprova più tardi.",
    buttonText: "Contact Us", // needs translation
  },
  "fr-fr": {
    headingText: "Une erreur s'est produite. Veuillez réessayer plus tard.",
    buttonText: "Nous Contacter",
  },
  "es-es": {
    headingText: "Se ha producido un error, inténtalo de nuevo más tarde.",
    buttonText: "Contacta con nosotros", // Validate
  },
};
